import { render, staticRenderFns } from "./LotPopup.vue?vue&type=template&id=740b10c8"
import script from "./LotPopup.vue?vue&type=script&lang=js"
export * from "./LotPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports